import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';
import reduce from 'lodash/reduce';

import {
  ADMIN_GET_DEFAULT_BLOCK_CONTENTS,
  ADMIN_OBSERVE_DEFAULT_BLOCK_CONTENTS,
  ActionFailureType,
  ActionSuccessType,
} from 'constants/redux-actions';
import { transformKey } from 'utils/content-key';

const defaultInitState = { loading: false, data: [] };
const initState = {
  global: defaultInitState,
  network: defaultInitState,
  site: defaultInitState,
  subnetwork: defaultInitState,
};

const transformPersistedDefaultContentsByBlocks = (defaultContents) =>
  reduce(
    defaultContents,
    (results, item) => {
      const { templateBlockId, key } = item;
      const transformedKey = transformKey(key);

      if (!results[templateBlockId]) {
        results[templateBlockId] = {};
      }

      results[templateBlockId][transformedKey] = item;

      return results;
    },
    {},
  );

const defaultBlockContentsReducer = createReducer(initState, {
  [ADMIN_GET_DEFAULT_BLOCK_CONTENTS]: (prevState, action) => {
    const specificType = get(action, 'payload.request.type', '');

    return { ...prevState, [specificType]: { loading: true, data: [] } };
  },
  [ActionSuccessType(ADMIN_GET_DEFAULT_BLOCK_CONTENTS)]: (prevState, action) => {
    const specificType = get(action, 'payload.config.type', '');
    const transformedData = transformPersistedDefaultContentsByBlocks(get(action.payload, 'data', []));

    return { ...prevState, [specificType]: { loading: false, data: transformedData } };
  },
  [ActionFailureType(ADMIN_GET_DEFAULT_BLOCK_CONTENTS)]: (prevState, action) => {
    const specificType = get(action, 'meta.previousAction.payload.request.type', '');

    return { ...prevState, [specificType]: defaultInitState };
  },
  [ADMIN_OBSERVE_DEFAULT_BLOCK_CONTENTS]: (prevState, action) => {
    const { networkId, siteId, subnetworkId, data } = action.payload;
    const transformedData = transformPersistedDefaultContentsByBlocks(data);
    const type = siteId ? 'site' : subnetworkId ? 'subnetwork' : networkId ? 'network' : 'global';

    return { ...prevState, [type]: { data: transformedData, loading: false } };
  },
});

export default defaultBlockContentsReducer;
